import React, { Component } from 'react';
import '../styles.css';
import Line from './Line';
import Dot from './Dot';
import Shape from './Shape';
import _ from 'lodash';
import { PLAYER1, PLAYER2, HINT } from '../const';
import { connect } from 'react-redux';
import * as f from '../logic';
import { Sound } from '../../HOME/Sound';
import { updateDots, updateLines, updateHints, updateShapes } from '../REDUX/actions';
import { setCurrentPlayer, restart } from '../REDUX/actions';
import { updateStats, setFromTo, updateCurrentTime, stopPlayback } from '../REDUX/actions';
import { requestResetStats, requestSurrender, showLeaderboards, SHOW_LEADERS, OVER_RESTART } from '../../HOME/REDUX/actions';
import MessageBox from '../../HOME/COMPONENTS/MessageBox';
import { delay, isNum, dbget, dbset } from '../../HOME/utils';
import { FAST, SLOW } from '../../HOME/const';
import GameOverOptions from '../../HOME/COMPONENTS/GameOverOptions';

class Board extends Component {
  state = {};
  blocked = false;
  roboClicks = [];
  timer = null;

  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.mounted = true;

    this.load();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    this.mounted = false;

    this.props.updateHints();
    this.props.requestResetStats(false);
    this.props.requestSurrender(false);

    if (this.props.playback) {
      this.props.stopPlayback();
    }
  }

  load() {
    dbget(f.boardKey(this.props), json => {
      if (!json) {
        this.loadDefault();
        return;
      }

      const savedProps = f.fromJson(json);
      delete savedProps.from;
      delete savedProps.to;

      if (!f.gameStarted(savedProps) || f.winnerInfo(savedProps).winner) {
        this.loadDefault();
        return;
      }

      this.props.updateDots(savedProps.dots);
      this.props.updateLines(savedProps.lines);
      this.props.updateShapes(savedProps.shapes);
      this.props.setCurrentPlayer(savedProps.currentPlayer);

      if (f.gameStarted(this.props)) {
        if (f.robot(savedProps)) {
          delay(() => this.letRobotMove(), SLOW);
        } else {
          this.updateHints();
        }
      }
    }, err => this.loadDefault());
  }

  loadDefault() {
    const { size } = this.props;
    const count = size * size;

    const dots = [];

    for (let i = 0; i < count; i++) {
      dots.push(new Dot());
    }

    this.props.updateDots(dots);
    this.restart(true);
  }

  restart = initial => {
    this.playSound('dice');
    this.props.restart(initial);
  };

  playSound = name => {
    Sound(name, this.props.globalOptions.volume);
  };

  save() {
    dbset(f.boardKey(this.props), f.toJson(this.props));
  }

  handleTouch = i => e => {
    this.touch = true;
    this.handleClick(i);
  };

  handleMouseDown = i => e => {
    if (!this.touch) {
      this.handleClick(i);
    }
  };

  handleClick = i => {
    if (this.blocked || f.robot(this.props)) {
      return;
    }

    var { dots } = this.props;

    if (f.disabled(dots[i]) || f.hidden(dots[i])) {
      return;
    }

    this.playSound('tap');

    this.processClick(i);
  };

  processClick = i => {
    if (!this.mounted) {
      return;
    }

    const { dots, lines, shapes, currentPlayer, surrender, resetStats, playback } = this.props;

    if (playback) {
      return;
    }

    const robot = f.robot(this.props);

    if (!robot && (surrender || resetStats)) {
      return;
    }

    let { from, to } = this.props;

    if (isNum(from)) {
      if (from === i) {
        from = undefined;
      } else if (isNum(to)) {
        if (to === i) {
          to = undefined;
        }
      } else if (f.canLink(from, i, this.props)) {
        to = i;
      }
    } else {
      from = i;
    }

    if (isNum(from)) {
      if (isNum(to)) {
        f.select(dots[to]);

        this.playSound(robot ? 'link2' : 'link1');

        _.each(lines, l => {
          if (!f.hidden(l)) {
            f.restoreVisibility(l);
          }
        });

        let duration = robot ? SLOW : FAST;
        const newShapes = f.addLine(from, to, this.props, duration);

        this.lineDrawTimeout(duration);

        if (newShapes.length) {
          delay(() => {
            _.each(newShapes, s => {
              s.easein = SLOW;
            });

            shapes.push(...newShapes);
            f.onShapesAdded(this.props);

            this.playSound(robot ? 'score2' : 'score1');

            this.save();
            f.setStats(this.props, this.props.updateStats);

            this.props.updateCurrentTime();

            const sound = f.winnerInfo(this.props).sound;

            if (sound) {
              delay(() => this.playSound(sound), SLOW);
            }
          }, duration * 2);
        } else {
          this.props.setCurrentPlayer(currentPlayer === PLAYER1 ? PLAYER2 : PLAYER1);
        }

        this.updateHints();
      } else {
        f.select(dots[from]);

        if (robot) {
          this.letRobotMove();
        } else {
          f.onFromSelected(from, this.props);
        }
      }
    } else {
      this.restoreDotsVisibility();
    }

    this.props.setFromTo({ from, to });
  };

  continuePlayback = () => {
    if (!this.mounted) {
      return;
    }

    const { playbackLines, dots, lines, currentPlayer, shapes } = this.props;

    if (!playbackLines.length) {
      this.stopPlayback();
      return;
    }

    if (this.props.playbackPaused) {
      delay(() => {
        if (this.props.playback) {
          this.continuePlayback();
        }
      }, 1000);
      return;
    }

    const l = playbackLines.shift();
    const from = l.from;
    const to = l.to;

    f.select(dots[from]);
    f.select(dots[to]);

    _.each(lines, l => {
      if (!f.hidden(l)) {
        f.restoreVisibility(l);
      }
    });

    let duration = SLOW;
    const newShapes = f.addLine(from, to, this.props, duration);

    this.lineDrawTimeout(duration);

    if (newShapes.length) {
      delay(() => {
        _.each(newShapes, s => {
          s.easein = SLOW;
        });

        shapes.push(...newShapes);
        f.onShapesAdded(this.props);

        if (!this.props.playback) {
          this.save();
          f.setStats(this.props, this.props.updateStats);
        }

        this.props.updateCurrentTime();
      }, duration * 2);
    } else {
      delay(() => this.props.setCurrentPlayer(currentPlayer === PLAYER1 ? PLAYER2 : PLAYER1), 700);
    }

    this.props.setFromTo({ from, to });
  };

  stopPlayback = () => {
    this.props.stopPlayback();
    this.blocked = false;

    if (!f.winnerInfo(this.props).winner) {
      this.load();
    }
  };

  updateHints = () => {
    clearInterval(this.timer);
    this.props.updateHints();

    if (!this.canHint()) {
      return;
    }

    this.timer = setInterval(() => {
      clearInterval(this.timer);

      if (!this.canHint()) {
        return;
      }

      const hints = f.getHints(this.props);

      if (hints.length) {
        this.props.updateHints(hints);
      }
    }, 5000);
  };

  canHint = () => {
    return this.props.options.hints && (!f.solo(this.props) || this.props.currentPlayer === PLAYER1);
  };

  lineDrawTimeout = duration => {
    this.blocked = true;

    delay(() => {
      this.restoreDotsVisibility();
      this.props.setFromTo({});

      if (this.props.playback) {
        delay(() => this.continuePlayback(), 2 * SLOW);
      } else {
        this.blocked = false;
        this.save();
        this.letRobotMove();
      }
    }, duration);
  };

  letRobotMove = () => {
    if (f.robot(this.props) && !this.roboClick()) {
      f.roboMove(this.props, this.processRoboClicks);
    }
  };

  processRoboClicks = clicks => {
    this.roboClicks = clicks;
    this.roboClick();
  };

  roboClick = () => {
    if (this.roboClicks && this.roboClicks.length) {
      let duration = FAST;

      if (this.roboClicks.length === 2 && (this.props.from || this.props.to)) {
        this.props.setFromTo({});
        duration = SLOW;
      }

      const i = this.roboClicks.shift();
      delay(() => this.processClick(i), duration);

      return true;
    }

    return false;
  };

  restoreDotsVisibility = () => {
    _.each(this.props.dots, d => {
      if (!f.hidden(d)) {
        f.restoreVisibility(d);
      }
    });
  };

  xy = (i, dim) => {
    const { size } = this.props;
    const { row, col } = f.rowCol(i, size);
    const step = dim / (size - 1);
    const x = col * step;
    const y = row * step;

    return { x, y };
  };

  handleGameOver = op => {
    if (op === SHOW_LEADERS) {
      this.props.showLeaderboards();
    } else if (op === OVER_RESTART) {
      this.restart();
      this.roboClicks = [];
    }
  };

  handleTapToStart = () => {
    delay(() => {
      this.blocked = true;
      this.forceUpdate();
    });

    if (this.props.playback) {
      delay(() => this.continuePlayback());
    } else {
      this.letRobotMove();
    }
  };

  handleConfirmSurrender = yes => {
    if (yes) {
      f.setStats(this.props, this.props.updateStats, true);
      this.restart();
      this.roboClicks = [];
    }

    delay(() => this.props.requestSurrender(false));
  };

  handleConfirmResetStats = yes => {
    if (yes) {
      this.props.updateStats();
    }

    delay(() => this.props.requestResetStats(false));
  };

  render() {
    const { dots, lines, hints, shapes, size, currentPlayer, resetStats } = this.props;
    const bw = f.boardWidth(this.props);
    const width = `${bw}px`;
    const clickSize = bw / (size - 1);
    const { winner, winnerMessage } = f.winnerInfo(this.props);
    const background = f.playerColor(winner);

    const tapToStart =
      !resetStats && !f.gameStarted(this.props) && (this.props.playback || (f.solo(this.props) && currentPlayer === PLAYER2 && !this.blocked));

    const tapToStartMessage = tapToStart ? `Tap to start${this.props.playback ? ' playback' : ''}` : '';

    return (
      <>
        <div className="board" style={{ background, width, height: width }}>
          {_.map(shapes, (s, i) => {
            const p1 = this.xy(s.i1, bw);
            const p2 = this.xy(s.i2, bw);
            const p3 = this.xy(s.i3, bw);
            return <Shape key={i} p1={p1} p2={p2} p3={p3} color={f.playerColor(s.player)} easein={s.easein} />;
          })}
          {_.map(lines, (l, i) => {
            if (f.hidden(l)) {
              return null;
            }
            const p1 = this.xy(l.from, bw);
            const p2 = this.xy(l.to, bw);
            return <Line key={i} p1={p1} p2={p2} visibility={l.visibility} winner={winner} />;
          })}
          {this.props.options.hints
            ? _.map(hints, (l, i) => {
                const p1 = this.xy(l.from, bw);
                const p2 = this.xy(l.to, bw);
                return <Line key={i} p1={p1} p2={p2} visibility={HINT} currentPlayer={currentPlayer} />;
              })
            : null}
          {_.map(dots, (d, i) => {
            if (f.hidden(d)) {
              return null;
            }
            const { x, y } = this.xy(i, bw);
            return (
              <Dot
                key={i}
                x={x}
                y={y}
                clickSize={clickSize}
                visibility={d.visibility}
                onTouch={this.handleTouch(i)}
                onMouseDown={this.handleMouseDown(i)}
              />
            );
          })}
        </div>
        {winner && !resetStats && <GameOverOptions header={winnerMessage} handleResponse={this.handleGameOver} style={{ gridArea: '2/1' }} />}
        {tapToStart && <MessageBox message={tapToStartMessage} width={width} area="2/1" onReply={this.handleTapToStart} />}
        {this.props.surrender && (
          <MessageBox
            message={f.solo(this.props) ? 'Surrender?' : 'Start over?'}
            yesNo
            width={width}
            area="2/1"
            onReply={this.handleConfirmSurrender}
          />
        )}
        {resetStats && <MessageBox message="Reset stats?" yesNo width={width} area="2/1" onReply={this.handleConfirmResetStats} />}
      </>
    );
  }
}

function mapStateToProps({ ta, common }) {
  return { ...ta, ...common };
}

export default connect(
  mapStateToProps,
  {
    updateDots,
    updateLines,
    updateHints,
    updateShapes,
    setCurrentPlayer,
    restart,
    updateStats,
    updateCurrentTime,
    setFromTo,
    requestSurrender,
    requestResetStats,
    stopPlayback,
    showLeaderboards,
  },
  null,
  { forwardRef: true }
)(Board);
